(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define('@gradii/stream-buffer', ['exports'], factory) :
    (global = global || self, factory((global.gradii = global.gradii || {}, global.gradii.streamBuffer = {})));
}(this, function (exports) { 'use strict';

    /**
     *
     */
    var StreamInputBuffer = /** @class */ (function () {
        /**
         * A buffer walker.
         * @param buffer Array buffer.
         * @param bigEndian Use big endian for numbers. (default: little endian)
         */
        function StreamInputBuffer(buffer) {
            this.buffer = buffer;
            this.offset = 0;
        }
        /**
         * Returns the array buffer of the data view.
         * @return The buffer of this data view.
         */
        StreamInputBuffer.prototype.getBuffer = function () {
            var buffer = new Buffer(this.offset);
            this.buffer.copy(buffer, 0, 0, this.offset);
            return buffer;
        };
        /**
         * Returns the length in bytes of this stream buffer.
         */
        StreamInputBuffer.prototype.getLength = function () {
            return this.buffer.byteLength;
        };
        /**
         * Moves the offset relative in a direction.
         * @param length Positive or negative number byte length.
         */
        StreamInputBuffer.prototype.skip = function (length) {
            this.offset += length;
        };
        /**
         * Moves the offset to zero.
         */
        StreamInputBuffer.prototype.resetOffset = function () {
            this.offset = 0;
        };
        /**
         * Returns the current offset.
         * @return Offset
         */
        StreamInputBuffer.prototype.getOffset = function () {
            return this.offset;
        };
        /**
         * Sets a new offset to an absolute position.
         * @param offset New offset (starts from zero)
         */
        StreamInputBuffer.prototype.setOffset = function (offset) {
            this.offset = offset;
        };
        StreamInputBuffer.prototype.read = function (length) {
            var value = this.buffer.slice(this.offset, this.offset + length);
            this.offset += length;
            return value;
        };
        StreamInputBuffer.prototype.readString = function (length, encoding) {
            var value = this.buffer.toString(encoding, this.offset, length);
            this.offset += length;
            return value;
        };
        // public readHex(length: number, space = false): string {
        //   if (space) {
        //     let rtn = this.buffer.toString('hex', this.offset, ++this.offset)
        //     for (let i = 1; i < length; i++) {
        //       rtn += ' ' + this.buffer.toString('hex', this.offset, ++this.offset)
        //     }
        //     return rtn;
        //   }
        //
        //   return this.buffer.toString('hex', this.offset, this.offset + length);
        // }
        /**
         * Reads the next 8-bit singed integer from current offset.
         * @return INT8 value.
         */
        StreamInputBuffer.prototype.readInt8 = function () {
            var value = this.buffer.readInt8(this.offset);
            this.offset += 1;
            return value;
        };
        /**
         * Reads the next 8-bit unsinged integer from curret offset.
         * @return UINT8 value.
         */
        StreamInputBuffer.prototype.readUInt8 = function () {
            var value = this.buffer.readUInt8(this.offset);
            this.offset += 1;
            return value;
        };
        /**
         * Reads the next 16-bit singed integer.
         * @return INT16 value.
         */
        StreamInputBuffer.prototype.readInt16BE = function () {
            var value = this.buffer.readInt16BE(this.offset);
            this.offset += 2;
            return value;
        };
        StreamInputBuffer.prototype.readInt16LE = function () {
            var value = this.buffer.readInt16LE(this.offset);
            this.offset += 2;
            return value;
        };
        /**
         * Reads the next 16-bit unsinged integer.
         * @return UINT16 value.
         */
        StreamInputBuffer.prototype.readUInt16BE = function () {
            var value = this.buffer.readUInt16BE(this.offset);
            this.offset += 2;
            return value;
        };
        StreamInputBuffer.prototype.readUInt16LE = function () {
            var value = this.buffer.readUInt16LE(this.offset);
            this.offset += 2;
            return value;
        };
        /**
         * Reads the next 32-bit singed integer.
         * @return INT32 value.
         */
        StreamInputBuffer.prototype.readInt32BE = function () {
            var value = this.buffer.readInt32BE(this.offset);
            this.offset += 4;
            return value;
        };
        StreamInputBuffer.prototype.readInt32LE = function () {
            var value = this.buffer.readInt32LE(this.offset);
            this.offset += 4;
            return value;
        };
        /**
         * Reads the next 32-bit unsinged integer.
         * @return UINT32 value.
         */
        StreamInputBuffer.prototype.readUInt32BE = function () {
            var value = this.buffer.readUInt32BE(this.offset);
            this.offset += 4;
            return value;
        };
        StreamInputBuffer.prototype.readUInt32LE = function () {
            var value = this.buffer.readUInt32LE(this.offset);
            this.offset += 4;
            return value;
        };
        /**
         * Reads the next 64-bit singed integer.
         * @return INT64 value.
         */
        StreamInputBuffer.prototype.readBigInt64BE = function () {
            var value = this.buffer.readBigInt64BE(this.offset);
            this.offset += 8;
            return value;
        };
        StreamInputBuffer.prototype.readBigInt64LE = function () {
            var value = this.buffer.readBigInt64LE(this.offset);
            this.offset += 8;
            return value;
        };
        /**
         * Reads the next 64-bit unsinged integer.
         * @return UINT64 value.
         */
        StreamInputBuffer.prototype.readBigUInt64BE = function () {
            var value = this.buffer.readBigUInt64BE(this.offset);
            this.offset += 8;
            return value;
        };
        StreamInputBuffer.prototype.readBigUInt64LE = function () {
            var value = this.buffer.readBigUInt64LE(this.offset);
            this.offset += 8;
            return value;
        };
        /**
         * Reads the next float. (32-bit, signed)
         * @return FLOAT value.
         */
        StreamInputBuffer.prototype.readFloatBE = function () {
            var value = this.buffer.readFloatBE(this.offset);
            this.offset += 4;
            return value;
        };
        /**
         * Reads the next double. (32-bit, signed)
         * @return DOUBLE value.
         */
        StreamInputBuffer.prototype.readFloatLE = function () {
            var value = this.buffer.readFloatLE(this.offset);
            this.offset += 4;
            return value;
        };
        /**
         * Reads the next double. (64-bit, signed)
         * @return FLOAT value.
         */
        StreamInputBuffer.prototype.readDoubleBE = function () {
            var value = this.buffer.readDoubleBE(this.offset);
            this.offset += 8;
            return value;
        };
        /**
         * Reads the next double. (64-bit, signed)
         * @return DOUBLE value.
         */
        StreamInputBuffer.prototype.readDoubleLE = function () {
            var value = this.buffer.readDoubleLE(this.offset);
            this.offset += 8;
            return value;
        };
        StreamInputBuffer.prototype.readIntBE = function (length) {
            var value = this.buffer.readIntBE(this.offset, length);
            this.offset += length;
            return value;
        };
        StreamInputBuffer.prototype.readIntLE = function (length) {
            var value = this.buffer.readIntLE(this.offset, length);
            this.offset += length;
            return value;
        };
        StreamInputBuffer.prototype.readUIntBE = function (length) {
            var value = this.buffer.readUIntBE(this.offset, length);
            this.offset += length;
            return value;
        };
        StreamInputBuffer.prototype.readUIntLE = function (length) {
            var value = this.buffer.readUIntLE(this.offset, length);
            this.offset += length;
            return value;
        };
        return StreamInputBuffer;
    }());

    /**
     *
     */
    var StreamOutputBuffer = /** @class */ (function () {
        /**
         * A buffer walker.
         * @param size
         */
        function StreamOutputBuffer(size) {
            this.offset = 0;
            this.capacity = 32;
            if (size > 0) {
                this.capacity = size;
            }
            this.buffer = new Buffer(this.capacity);
        }
        StreamOutputBuffer.prototype.getLength = function () {
            return this.offset;
        };
        StreamOutputBuffer.prototype.getBuffer = function () {
            var buffer = new Buffer(this.offset);
            this.buffer.copy(buffer, 0, 0, this.offset);
            return buffer;
        };
        StreamOutputBuffer.prototype.checkCapacity = function (length) {
            if (this.offset + length > this.capacity) {
                length = length < 32 ? 32 : length;
                this.capacity = this.capacity + length << 1;
                var buffer = new Buffer(this.capacity);
                this.buffer.copy(buffer);
                this.buffer = buffer;
            }
        };
        StreamOutputBuffer.prototype.skip = function (length) {
            this.checkCapacity(length);
            this.offset += length;
        };
        StreamOutputBuffer.prototype.fill = function (value, length, encoding) {
            this.checkCapacity(length);
            this.buffer.fill(value, this.offset, length, encoding);
            this.offset += length;
        };
        StreamOutputBuffer.prototype.writeAt = function (buffer, offset, sourceStart, sourceEnd) {
            if (offset === void 0) { offset = this.offset; }
            if (sourceStart === void 0) { sourceStart = 0; }
            if (sourceEnd === void 0) { sourceEnd = buffer.length; }
            var length = sourceEnd - sourceStart;
            if (offset + length > this.offset) {
                this.checkCapacity(offset + length);
                this.offset = offset + length;
            }
            buffer.copy(this.buffer, offset, sourceStart, sourceEnd);
        };
        /**
         * //@deprecated will be use fill instead
         * @param buffer
         * @param sourceStart
         * @param sourceEnd
         */
        StreamOutputBuffer.prototype.write = function (buffer, sourceStart, sourceEnd) {
            if (sourceStart === void 0) { sourceStart = 0; }
            if (sourceEnd === void 0) { sourceEnd = buffer.length; }
            var length = sourceEnd - sourceStart;
            this.checkCapacity(length);
            buffer.copy(this.buffer, this.offset, sourceStart, sourceEnd);
            this.offset += length;
        };
        /**
         * //@deprecated will be use write instead
         *
         * @param string
         * @param length
         * @param encoding
         */
        StreamOutputBuffer.prototype.writeString = function (string, length, encoding) {
            this.checkCapacity(length);
            this.buffer.write(string, this.offset, length, encoding);
            this.offset += length;
        };
        StreamOutputBuffer.prototype.writeInt8 = function (value) {
            this.checkCapacity(1);
            this.buffer.writeInt8(value, this.offset);
            this.offset += 1;
        };
        StreamOutputBuffer.prototype.writeUInt8 = function (value) {
            this.checkCapacity(1);
            this.buffer.writeUInt8(value, this.offset);
            this.offset += 1;
        };
        StreamOutputBuffer.prototype.writeInt16BE = function (value) {
            this.checkCapacity(2);
            this.buffer.writeInt16BE(value, this.offset);
            this.offset += 2;
        };
        StreamOutputBuffer.prototype.writeInt16LE = function (value) {
            this.checkCapacity(2);
            this.buffer.writeInt16LE(value, this.offset);
            this.offset += 2;
        };
        StreamOutputBuffer.prototype.writeUInt16BE = function (value) {
            this.checkCapacity(2);
            this.buffer.writeUInt16BE(value, this.offset);
            this.offset += 2;
        };
        StreamOutputBuffer.prototype.writeUInt16LE = function (value) {
            this.checkCapacity(2);
            this.buffer.writeUInt16LE(value, this.offset);
            this.offset += 2;
        };
        StreamOutputBuffer.prototype.writeInt32BE = function (value) {
            this.checkCapacity(4);
            this.buffer.writeInt32BE(value, this.offset);
            this.offset += 4;
        };
        StreamOutputBuffer.prototype.writeInt32LE = function (value) {
            this.checkCapacity(4);
            this.buffer.writeInt32LE(value, this.offset);
            this.offset += 4;
        };
        StreamOutputBuffer.prototype.writeUInt32BE = function (value) {
            this.checkCapacity(4);
            this.buffer.writeUInt32BE(value, this.offset);
            this.offset += 4;
        };
        StreamOutputBuffer.prototype.writeUInt32LE = function (value) {
            this.checkCapacity(4);
            this.buffer.writeUInt32LE(value, this.offset);
            this.offset += 4;
        };
        StreamOutputBuffer.prototype.writeBigInt64BE = function (value, offset) {
            this.checkCapacity(8);
            this.buffer.writeBigInt64BE(value, this.offset);
            this.offset += 8;
        };
        StreamOutputBuffer.prototype.writeBigInt64LE = function (value, offset) {
            this.checkCapacity(8);
            this.buffer.writeBigInt64LE(value, this.offset);
            this.offset += 8;
        };
        StreamOutputBuffer.prototype.writeBigUInt64BE = function (value, offset) {
            this.checkCapacity(8);
            this.buffer.writeBigUInt64BE(value, this.offset);
            this.offset += 8;
        };
        StreamOutputBuffer.prototype.writeBigUInt64LE = function (value, offset) {
            this.checkCapacity(8);
            this.buffer.writeBigUInt64LE(value, this.offset);
            this.offset += 8;
        };
        StreamOutputBuffer.prototype.writeFloatBE = function (value) {
            this.checkCapacity(4);
            this.buffer.writeFloatBE(value, this.offset);
            this.offset += 4;
        };
        StreamOutputBuffer.prototype.writeFloatLE = function (value) {
            this.checkCapacity(4);
            this.buffer.writeFloatLE(value, this.offset);
            this.offset += 4;
        };
        StreamOutputBuffer.prototype.writeDoubleBE = function (value) {
            this.checkCapacity(8);
            this.buffer.writeDoubleBE(value, this.offset);
            this.offset += 8;
        };
        StreamOutputBuffer.prototype.writeDoubleLE = function (value) {
            this.checkCapacity(8);
            this.buffer.writeDoubleLE(value, this.offset);
            this.offset += 8;
        };
        StreamOutputBuffer.prototype.writeIntBE = function (value, byteLength) {
            this.checkCapacity(byteLength);
            this.buffer.writeIntBE(value, this.offset, byteLength);
            this.offset += byteLength;
        };
        StreamOutputBuffer.prototype.writeIntLE = function (value, byteLength) {
            this.checkCapacity(byteLength);
            this.buffer.writeIntLE(value, this.offset, byteLength);
            this.offset += byteLength;
        };
        StreamOutputBuffer.prototype.writeUIntBE = function (value, byteLength) {
            this.checkCapacity(byteLength);
            this.buffer.writeUIntBE(value, this.offset, byteLength);
            this.offset += byteLength;
        };
        StreamOutputBuffer.prototype.writeUIntLE = function (value, byteLength) {
            this.checkCapacity(byteLength);
            this.buffer.writeUIntLE(value, this.offset, byteLength);
            this.offset += byteLength;
        };
        return StreamOutputBuffer;
    }());

    var BitStreamInputBuffer = /** @class */ (function () {
        function BitStreamInputBuffer(is) {
            this.is = is;
            this.nBit = 0;
            this.curByte = 0;
            this.nextByte = 0;
            this.curByte = is.readUInt8();
            this.nextByte = is.readUInt8();
        }
        BitStreamInputBuffer.prototype.readBool = function () {
            return this.read1Bit() === 1;
        };
        BitStreamInputBuffer.prototype.read1Bit = function () {
            if (this.nBit === 8) {
                this.advance();
                if (this.curByte === -1) {
                    return -1;
                }
            }
            var res = (this.curByte >> (7 - this.nBit)) & 1;
            this.nBit++;
            return res;
        };
        BitStreamInputBuffer.prototype.readNBit = function (n) {
            if (n > 64)
                throw new Error('Can not readByte more then 64 bit');
            var val = 0;
            for (var i = 0; i < n; i++) {
                {
                    val <<= 1;
                    val |= this.read1Bit();
                }
            }
            return val;
        };
        BitStreamInputBuffer.prototype.advance = function () {
            this.curByte = this.nextByte;
            this.nextByte = this.is.readUInt8();
            this.nBit = 0;
        };
        BitStreamInputBuffer.prototype.readByte = function () {
            if (this.nBit > 0) {
                this.advance();
            }
            var res = this.curByte;
            this.advance();
            return res;
        };
        BitStreamInputBuffer.prototype.moreRBSPData = function () {
            if (this.nBit === 8) {
                this.advance();
            }
            var tail = 1 << (8 - this.nBit - 1);
            var mask = ((tail << 1) - 1);
            var hasTail = (this.curByte & mask) === tail;
            return !(this.curByte === -1 || (this.nextByte === -1 && hasTail));
        };
        BitStreamInputBuffer.prototype.readRemainingByte = function () {
            return this.readNBit(8 - this.nBit);
        };
        BitStreamInputBuffer.prototype.peakNextBits = function (n) {
            if (n > 8)
                throw new Error('N should be less then 8');
            if (this.nBit === 8) {
                this.advance();
                if (this.curByte === -1) {
                    return -1;
                }
            }
            var bits = new Uint8Array(16 - this.nBit);
            var cnt = 0;
            for (var i = this.nBit; i < 8; i++) {
                bits[cnt++] = (this.curByte >> (7 - i)) & 1;
            }
            for (var i = 0; i < 8; i++) {
                bits[cnt++] = (this.nextByte >> (7 - i)) & 1;
            }
            var result = 0;
            for (var i = 0; i < n; i++) {
                result <<= 1;
                result |= bits[i];
            }
            return result;
        };
        BitStreamInputBuffer.prototype.isByteAligned = function () {
            return (this.nBit % 8) === 0;
        };
        BitStreamInputBuffer.prototype.close = function () {
        };
        BitStreamInputBuffer.prototype.getCurBit = function () {
            return this.nBit;
        };
        BitStreamInputBuffer.bitsRead = 0;
        return BitStreamInputBuffer;
    }());

    var BitStreamOutputBuffer = /** @class */ (function () {
        function BitStreamOutputBuffer(os) {
            this.os = os;
            this.curByte = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]);
            this.curBit = 0;
        }
        BitStreamOutputBuffer.prototype.flush = function () {
            for (var i = this.curBit; i < 8; i++) {
                {
                    this.curByte[i] = 0;
                }
            }
            this.curBit = 0;
            this.writeCurByte();
        };
        BitStreamOutputBuffer.prototype.writeCurByte = function () {
            var toWrite = (this.curByte[0] << 7) |
                (this.curByte[1] << 6) |
                (this.curByte[2] << 5) |
                (this.curByte[3] << 4) |
                (this.curByte[4] << 3) |
                (this.curByte[5] << 2) |
                (this.curByte[6] << 1) |
                this.curByte[7];
            this.os.writeUInt8(toWrite);
        };
        BitStreamOutputBuffer.prototype.write1Bit = function (value) {
            if (this.curBit === 8) {
                this.curBit = 0;
                this.writeCurByte();
            }
            this.curByte[this.curBit++] = value;
        };
        BitStreamOutputBuffer.prototype.writeNBit = function (value, n) {
            for (var i = 0; i < n; i++) {
                {
                    this.write1Bit(((value >> (n - i - 1)) | 0) & 1);
                }
            }
        };
        BitStreamOutputBuffer.prototype.writeRemainingZero = function () {
            this.writeNBit(0, 8 - this.curBit);
        };
        BitStreamOutputBuffer.prototype.writeByte = function (b) {
            this.os.writeUInt8(b);
        };
        return BitStreamOutputBuffer;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.StreamInputBuffer = StreamInputBuffer;
    exports.StreamOutputBuffer = StreamOutputBuffer;
    exports.BitStreamInputBuffer = BitStreamInputBuffer;
    exports.BitStreamOutputBuffer = BitStreamOutputBuffer;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=stream-buffer.umd.js.map
